import { render, staticRenderFns } from "./RegistryTypeName.vue?vue&type=template&id=290d0df0&scoped=true&"
import script from "./RegistryTypeName.vue?vue&type=script&lang=js&"
export * from "./RegistryTypeName.vue?vue&type=script&lang=js&"
import style0 from "./RegistryTypeName.vue?vue&type=style&index=0&id=290d0df0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290d0df0",
  null
  
)

export default component.exports